import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'element-plus/dist/index.css'
import { slider, slideritem } from 'vue-concise-slider'

Vue.config.productionTip = false

Vue.use(element);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
